import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./AchievementGrid.css";

import {
    Lock,
    CheckCircle,
    Star,
    X,
    Gift
} from "lucide-react";


const AchievementGrid = () => {

    const email =
        localStorage.getItem(
            "user_email"
        );


    const [
        achievements,
        setAchievements
    ] = useState([]);


    const [
        loading,
        setLoading
    ] = useState(true);


    /* ==========================================
       CLAIM MODAL
    ========================================== */

    const [
        selectedAchievement,
        setSelectedAchievement
    ] = useState(null);


    const [
        claimLoading,
        setClaimLoading
    ] = useState(false);


    /* ==========================================
       LOAD ACHIEVEMENTS
    ========================================== */

    useEffect(() => {

        if (email) {

            loadAchievements();

        }

    }, [email]);


    const loadAchievements = async () => {

        try {

            const res =
                await axios.get(

                    `/api/ignite/profile/${email}`

                );


            setAchievements(

                res.data.allAchievements || []

            );

        }

        catch (err) {

            console.error(
                "Achievement Error:",
                err
            );

        }

        finally {

            setLoading(false);

        }

    };


    /* ==========================================
       OPEN CLAIM MODAL
    ========================================== */

    const openClaimModal = (
        achievement
    ) => {

        if (
            !achievement.unlocked ||
            achievement.claimed
        ) {

            return;

        }


        setSelectedAchievement(
            achievement
        );

    };


    /* ==========================================
       CLOSE MODAL
    ========================================== */

    const closeClaimModal = () => {

        if (claimLoading) {

            return;

        }


        setSelectedAchievement(
            null
        );

    };


    /* ==========================================
       CLAIM ACHIEVEMENT
       
       FRONTEND ONLY FOR NOW
    ========================================== */

    const claimAchievement = async () => {

    if (!selectedAchievement) {

        return;

    }

    try {

        setClaimLoading(true);

        const res =
            await axios.patch(

                "/api/achievement/claim",

                {

                    email,

                    badgeId:
                        selectedAchievement.badgeId

                }

            );


        if (res.data.success) {

            setAchievements(

                prev =>

                    prev.map(item =>

                        item.badgeId ===
                        selectedAchievement.badgeId

                            ?

                            {
                                ...item,
                                claimed: true
                            }

                            :

                            item

                    )

            );


            setSelectedAchievement(
                null
            );

        }

    }

    catch (err) {

        console.error(
            "Claim Achievement Error:",
            err
        );

        alert(

            err.response?.data?.message ||

            "Unable to claim achievement."

        );

    }

    finally {

        setClaimLoading(false);

    }

};

    /* ==========================================
       LOADING
    ========================================== */

    if (loading) {

        return (

            <div
                className=
                    "achievement-grid-loading"
            >

                Loading...

            </div>

        );

    }


    return (

        <>

            {/* ==================================
                ACHIEVEMENT GRID
            ================================== */}

            <div className="achievement-grid">

                {

                    achievements.map(

                        achievement => (

                            <div

                                key={
                                    achievement.badgeId
                                }

                                className={`
                                    achievement-card
                                    ${
                                        achievement.unlocked
                                            ? "unlocked"
                                            : "locked"
                                    }
                                `}

                            >

                                {/* ==========================
                                    TOP
                                ========================== */}

                                <div
                                    className=
                                        "achievement-top"
                                >

                                    <div
                                        className=
                                            "achievement-icon"
                                    >

                                        {

                                            achievement.icon

                                                ?

                                                <img

                                                    src={
                                                        achievement.icon
                                                    }

                                                    alt={
                                                        achievement.title
                                                    }

                                                />

                                                :

                                                "🏆"

                                        }

                                    </div>


                                    {

                                        achievement.unlocked

                                            ?

                                            <CheckCircle

                                                className=
                                                    "unlock-icon"

                                                size={24}

                                            />

                                            :

                                            <Lock

                                                className=
                                                    "lock-icon"

                                                size={22}

                                            />

                                    }

                                </div>


                                {/* ==========================
                                    TITLE
                                ========================== */}

                                <h3>

                                    {
                                        achievement.title
                                    }

                                </h3>


                                {/* ==========================
                                    DESCRIPTION
                                ========================== */}

                                <p>

                                    {
                                        achievement.description
                                    }

                                </p>


                                {/* ==========================
                                    FOOTER
                                ========================== */}

                                <div
                                    className=
                                        "achievement-footer"
                                >

                                    <span>

                                        <Star
                                            size={16}
                                        />

                                        {
                                            achievement.xp
                                        }

                                        {" XP"}

                                    </span>


                                    {

                                        achievement.claimed

                                            ?

                                            <button
                                                disabled
                                            >

                                                Claimed

                                            </button>

                                            :

                                        achievement.unlocked

                                            ?

                                            <button

                                                onClick={() =>
                                                    openClaimModal(
                                                        achievement
                                                    )
                                                }

                                            >

                                                Claim

                                            </button>

                                            :

                                            <button
                                                disabled
                                            >

                                                Locked

                                            </button>

                                    }

                                </div>

                            </div>

                        )

                    )

                }

            </div>


            {/* ==================================
                CLAIM MODAL
            ================================== */}

            {

                selectedAchievement && (

                    <div
                        className=
                            "claim-modal-overlay"

                        onClick={
                            closeClaimModal
                        }

                    >

                        <div

                            className=
                                "claim-modal"

                            onClick={e =>
                                e.stopPropagation()
                            }

                        >

                            {/* =========================
                                HEADER
                            ========================= */}

                            <div
                                className=
                                    "claim-modal-header"
                            >

                                <div
                                    className=
                                        "claim-title"
                                >

                                    <div
                                        className=
                                            "claim-gift-icon"
                                    >

                                        <Gift
                                            size={25}
                                        />

                                    </div>

                                    <h2>

                                        Claim Achievement

                                    </h2>

                                </div>


                                <button

                                    className=
                                        "claim-close"

                                    onClick={
                                        closeClaimModal
                                    }

                                >

                                    <X
                                        size={24}
                                    />

                                </button>

                            </div>


                            {/* =========================
                                ACHIEVEMENT ICON
                            ========================= */}

                            <div
                                className=
                                    "claim-achievement-icon"
                            >

                                {

                                    selectedAchievement.icon

                                        ?

                                        <img

                                            src={
                                                selectedAchievement.icon
                                            }

                                            alt={
                                                selectedAchievement.title
                                            }

                                        />

                                        :

                                        <span>
                                            🏆
                                        </span>

                                }

                            </div>


                            {/* =========================
                                TITLE
                            ========================= */}

                            <h1
                                className=
                                    "claim-achievement-title"
                            >

                                {
                                    selectedAchievement.title
                                }

                            </h1>


                            {/* =========================
                                DESCRIPTION
                            ========================= */}

                            <p
                                className=
                                    "claim-achievement-description"
                            >

                                {
                                    selectedAchievement.description
                                }

                            </p>


                            {/* =========================
                                REWARD BOX
                            ========================= */}

                            <div
                                className=
                                    "claim-reward-box"
                            >

                                <div
                                    className=
                                        "claim-reward-item"
                                >

                                    <Star
                                        size={32}
                                        className=
                                            "claim-star"
                                    />

                                    <div>

                                        <span>
                                            You Earned
                                        </span>

                                        <strong>

                                            {
                                                selectedAchievement.xp
                                            }

                                            {" XP"}

                                        </strong>

                                    </div>

                                </div>


                                <div
                                    className=
                                        "claim-reward-divider"
                                />


                                <div
                                    className=
                                        "claim-reward-item"
                                >

                                    <CheckCircle
                                        size={32}
                                        className=
                                            "claim-success"
                                    />

                                    <div>

                                        <span>
                                            Status
                                        </span>

                                        <strong>
                                            Unlocked
                                        </strong>

                                    </div>

                                </div>

                            </div>


                            {/* =========================
                                ACTIONS
                            ========================= */}

                            <div
                                className=
                                    "claim-actions"
                            >

                                <button

                                    className=
                                        "claim-later-btn"

                                    onClick={
                                        closeClaimModal
                                    }

                                    disabled={
                                        claimLoading
                                    }

                                >

                                    Maybe Later

                                </button>


                                <button

                                    className=
                                        "claim-confirm-btn"

                                    onClick={
                                        claimAchievement
                                    }

                                    disabled={
                                        claimLoading
                                    }

                                >

                                    <Gift
                                        size={19}
                                    />

                                    {

                                        claimLoading

                                            ?

                                            "Claiming..."

                                            :

                                            "Claim"

                                    }

                                </button>

                            </div>

                        </div>

                    </div>

                )

            }

        </>

    );

};


export default AchievementGrid;